exports.NOTIFICATIONSERVICETYPES = {
  EMAIL: "email",
  EMAIL_MG: "email_mg", // mailgun template based emails
  HBS_EMAIL_MG: "hbs_email_mg", // notificationservice based template emails
  SMS: "sms",
  IN_APP: "inapp",
  IVRS: "ivrs",
  WHATS_APP: "whatsapp",
  PUSH_NOTIFICATION: "pushnotification",
  WEB_NOTIFICATION: "webnotification",
};
